import { Component, Prop, h, Element, State, Host } from "@stencil/core";
import { HeadingTag } from '@/globals/HeadingTag';

@Component({
  tag: 'pn-teaser-card',
  styleUrl: 'pn-teaser-card.scss'
})
export class PnTeaserCard {
  @Element() hostElement: HTMLElement;
  
  @Prop() text: string = null;
  @Prop() heading: string = null;
  @Prop() label?: string = null;
  @Prop() headingLevel?: string = 'h3';
  @Prop({ reflect: true }) dataCardColor: string = 'coral';
  @Prop({ reflect: true }) dataCardAlignment: string = 'left';

  @State() hasCtaSlotContent: boolean = false;
  @State() hasIllustrationSlot: boolean = true;

  componentWillLoad() {
    this.hasCtaSlotContent = !!this.hostElement.querySelector('[slot="cta"]');
    this.hasIllustrationSlot = !!this.hostElement.querySelector('[slot="illustration"]');
  }

  render() {
    const labelToCapitals = this.label?.toUpperCase();

    return (
      <Host>
        <slot name="clickable-block-wrapper" />
        <div class="pn-teaser-card__container">
          <div class={`pn-teaser-card__container__image__container ${!this.hasIllustrationSlot ? 'pn-teaser-card__container__image__container--no-image' : ''}`}>
            <slot name="illustration" />
          </div>
          <div class="pn-teaser-card__container__content">
            <div class="pn-teaser-card__container__content__text__container">
              {labelToCapitals && <span class="pn-teaser-card__container__content__text__container__label">{labelToCapitals}</span>}
              {this.heading && <HeadingTag level={this.headingLevel} cssClass="pn-teaser-card__container__content__text__container__heading">
                  {this.heading}
                </HeadingTag>}
              <p class="pn-teaser-card__container__content__text__container__preamble">{this.text}</p>
            </div>
            {this.hasCtaSlotContent && (
              <div class="pn-teaser-card__container__content__cta">
                <slot name="cta" />
              </div>
            )}
          </div>
        </div>
      </Host>
    );
  }
}
